import { useSelector } from 'react-redux';

import Global from '../store/global-selectors';
import { FeatureFlags } from '../feature-flags/feature-flags';

// TODO: Figure out a better solution for handling bulk rate shopper recommendations when a recommendable rate shopper is
//   disabled. Currently rate shopper recommendations only use the "Cheapest" default rate shopper, so for now we can
//   just treat the "Cheapest" rate shopper being disabled the same as having the feature flag off. Ideally the FE is
//   agnostic as to which rate shoppers are recommendable or not.

const CHEAPEST_SERVICE_COLLECTION_GUID = 'ada7df25-768f-4400-8c71-410c1c957941';

export const getIsBulkRateShopperRecommendationsEnabled = (state: object) => {
  const { enableAlternativeRatesRateShopperRecommendations } = new FeatureFlags({ state });
  const cheapestRateShopper = Global.selectSellerServiceCollectionByGuid(state, {
    serviceCollectionGuid: CHEAPEST_SERVICE_COLLECTION_GUID,
  });

  return enableAlternativeRatesRateShopperRecommendations && cheapestRateShopper?.isActive;
};

export const useIsBulkRateShopperRecommendationsEnabled = () => {
  return useSelector(getIsBulkRateShopperRecommendationsEnabled);
};
